import PropTypes from 'prop-types';
import { mapProps } from '../../../hoc/recompose';
import r from '../../../services/Replacement';
import EntityPreview from '../EntityPreview';
import PopupAlertContent from '../PopupAlertContent';
import { ObjectiveIcon } from '../icons';

export const ObjectiveCreatedAlert = mapProps(props => ({ ...props, action: 'Created' }))(ObjectiveAlert);
export const ObjectiveCopiedAlert = mapProps(props => ({ ...props, action: 'Copied' }))(ObjectiveAlert);
export const ObjectiveMovedAlert = mapProps(props => ({ ...props, action: 'Moved', showView: false }))(ObjectiveAlert);

function ObjectiveAlert({ objective, action, showView = true }) {
    const title = `${r('objective.singular.big')} ${action}`;
    const href = showView ? `/app/objectives/${objective.cycleId}/${objective.id}` : undefined;
    return (
        <PopupAlertContent title={title} href={href} icon={<ObjectiveIcon objective={objective} />}>
            <EntityPreview title={objective.title} subtitle={objective.cycle.name} />
        </PopupAlertContent>
    );
}

ObjectiveAlert.propTypes = {
    objective: PropTypes.shape({
        title: PropTypes.string.isRequired,
        cycle: PropTypes.shape({
            name: PropTypes.string.isRequired,
        }).isRequired,
        icon: PropTypes.string.isRequired,
    }).isRequired,
    action: PropTypes.string.isRequired,
    showView: PropTypes.bool,
};
